import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";

export const SALESLOFT_CONNECT_URL = `${SALES_API_BASE_URL}/sw-connector/salesloft/connect`;

export const SALESLOFT_CONNECT_POPUP_WIDTH = 600;
export const SALESLOFT_CONNECT_POPUP_HEIGHT = 650;
export const SALESLOFT_CONNECT_POLL_INTERVAL_MS = 1500;

export const SALESLOFT_FORBIDDEN_STATUS = 403;

export const SALESLOFT_CADENCES_PAGE_SIZE = 20;

export type SalesloftCadenceVisibility = "All" | "Private" | "Shared";

export const SALESLOFT_CADENCE_VISIBILITY = {
    all: "All",
    private: "Private",
    shared: "Shared",
} as const satisfies Record<string, SalesloftCadenceVisibility>;
